export default __webpack_public_path__ + "static/media/p2023-11.cd04ce2f.jpeg";